(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

function formatMoney(number, places, symbol, thousand, decimal) {
    number = number || 0;
    places = !isNaN(places = Math.abs(places)) ? places : 2;
    symbol = symbol !== undefined ? symbol : "$";
    thousand = thousand || ",";
    decimal = decimal || ".";
    var negative = number < 0 ? "-" : "",
        i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
}

new Vue({
    el: '.paginaLogin',

    data: {
        stepClass: 'in-step-1',
        boxTotalPagar: '0',
        inputNomeCompleto: '',
        inputEmail: ''
    },

    methods: {
        validaLogin: function validaLogin() {}
    }

});

new Vue({
    el: '.paginaDominio',
    data: {
        stepClass: 'in-step-2',
        boxTotalPagar: '0',
        classMensagemAlerta: '',
        boxMensagemAlerta: '',
        isSuccess: false,
        isDanger: false,
        boxCamposAdicionais: false,
        boxDadosCadastrais: false,
        boxSeguinte: false,
        btnLoading: false,
        valorDominio: 0,
        formularioCadastro: false,
        mostraFormularioCadastroOption: null,
        elementos: {},
        btnCadastro: false
    },
    methods: {
        limpar: function limpar() {
            var self = this;
            self.boxCamposAdicionais = false;
            self.boxDadosCadastrais = false;
            self.isSuccess = false;
            self.isDanger = false;
            self.boxSeguinte = false;
            self.boxTotalPagar = '0';
            self.boxMensagemAlerta = '';
            self.valorDominio = 0;
        },

        validaDominio: function validaDominio() {
            var self = this;
            self.boxCamposAdicionais = false;
            self.boxDadosCadastrais = false;
            self.isSuccess = false;
            self.isDanger = false;
            self.boxSeguinte = false;
            self.btnLoading = true;
            self.boxTotalPagar = '0';
            self.valorDominio = 0;

            this.$http.get('/api/dominios/' + this.inputTld + '/' + this.inputSld).then(function (resultado) {

                var retorno = resultado.data;
                if (retorno.result == 'success') {
                    var dominiosPy = ['.com.py', '.edu.py', '.net.py', '.org.py', '.coop.py', '.gov.py', '.mil.py'];
                    if (jQuery.inArray(self.inputSld, dominiosPy) != -1) {
                        self.boxCamposAdicionais = true;
                    }
                    self.isSuccess = true;
                    self.boxMensagemAlerta = retorno.message;
                    self.boxDadosCadastrais = true;
                    self.boxSeguinte = true;
                    self.boxTotalPagar = retorno.valor;
                    self.btnLoading = false;
                    self.valorDominio = retorno.valor;
                } else {
                    self.isDanger = true;
                    self.boxMensagemAlerta = retorno.message;
                    self.btnLoading = false;
                }
            }, function (resultado) {
                // error callback
            });
        },

        mostraFormularioCadastro: function mostraFormularioCadastro() {
            var self = this;
            self.formularioCadastro = false;
            self.elementos = {};

            if (self.mostraFormularioCadastroOption == 'novoContato') {
                self.formularioCadastro = true;
                self.btnCadastro = true;
            }

            if (!isNaN(parseInt(self.mostraFormularioCadastroOption))) {

                this.$http.get('/api/getcontacts/' + self.mostraFormularioCadastroOption).then(function (elemento) {
                    self.formularioCadastro = true;
                    self.elementos = elemento.data;
                    // console.log(elemento.data);
                }, function (resultado) {
                    // error callback
                });
            }
        },

        cadastraContato: function cadastraContato() {
            var self = this;

            var formularioCadastroContato = jQuery('#formularioCadastro').serialize();

            jQuery.ajax({
                url: '/dominio/addcontact',
                type: 'post',
                dataType: 'json',
                data: formularioCadastroContato,
                async: false,
                success: function success(data) {

                    jQuery('#contactid').append($('<option>', {
                        value: data.contactid,
                        text: data.nombre
                    }));

                    jQuery('#contactid').val(data.contactid);

                    alert('Registro realizado con éxito.');
                    self.elementos = {};
                    self.formularioCadastro = false;
                }

            }).fail(function (xhr) {
                var listaError = [];
                jQuery.each(jQuery.parseJSON(xhr.responseText), function (i, v) {
                    listaError.push(v);
                });
                alert('Atencion!\n\nVerifique los campos indicados e intente nuevamente.\n' + listaError.join('\n'));
            });
        }

    },

    ready: function ready() {

        this.validaDominio();
    }
});

new Vue({
    el: '.paginaPlanos',

    data: {
        stepClass: 'in-step-3',
        hiddenGID: '',
        hiddenPID: '',
        valorMensal: '0',
        valorSemestral: '0',
        valorAnual: '0',
        valor2Anos: '0',
        boxTotalPagar: 0
    },

    methods: {

        montarPlano: function montarPlano() {

            var self = this;
            var url = '/api/getproducts/' + self.hiddenGID + '/' + self.hiddenPID;

            self.valorMensal = 0;
            self.valorSemestral = 0;
            self.valorAnual = 0;
            self.valor2Anos = 0;
            self.boxTotalPagar = self.valorDominio;

            this.$http.get(url).then(function (response) {

                var dados = response.data.products.product[0].pricing.PYG;

                self.valorMensal = formatMoney(dados.monthly, 0, '', '.', '');
                self.valorSemestral = formatMoney(dados.semiannually, 0, '', '.', '');
                self.valorAnual = formatMoney(dados.annually, 0, '', '.', '');
                self.valor2Anos = formatMoney(dados.biennially, 0, '', '.', '');
            }, function (response) {
                // error callback
            });
        }

    },

    ready: function ready() {

        this.montarPlano();
    }
});

new Vue({
    el: '.paginaHosting',

    data: {
        stepClass: 'in-step-2'
    },

    methods: {}
});

new Vue({
    el: '.paginaConfirma',

    data: {
        stepClass: 'in-step-4'
    },

    methods: {}
});

new Vue({
    el: '.paginaPago',

    data: {
        stepClass: 'in-step-5'
    },

    methods: {}
});

$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
});



},{}]},{},[1]);
